import React from 'react';
import { NavLink, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import './navigation_tabs.less';
import { Badge } from 'antd';

let Tab = ({ tab, match, key, contactsCount = null }) => {
  return (
    <li key={key}>
      <NavLink
        activeClassName="active"
        to={match.url + (tab.to || '')}
        exact={!tab.to}>
        {tab.title}
        </NavLink>
    </li>
  );
};

Tab = connect(({ contactsCount }) => ({
  contactsCount
}))(Tab);

const NavigationTabs = ({ match, tabs, secondary }) => {
  return (
    <div>
      <div className={`navigation_tabs ${secondary ? 'secondary' : ''}`}>
        <ul>
          {tabs.map((tab, i) => (
            <Tab
              key={i}
              match={match}
              tab={tab}
            />
          ))}
        </ul>
      </div>

      <Switch>
        {tabs.map((tab, i) => {
          return (
            <Route
              key={i}
              path={match.url + (tab.to || '')}
              component={tab.component}
              exact={!tab.to}
            />
          );
        })}
      </Switch>
    </div>
  );
};

export default NavigationTabs;
